import { on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import {AsyncActions, MmsAdminActions} from './mms-admin-override.actions';
import { ManagementBaseActions } from '../base/management-base.actions';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {LocationSet} from '@emm/core/models/location-set.model';
import {SearchFilter} from '@emm/core/models/search-filter';
import {withLoadables} from '@emm/core/util/ngrx.util';

export const mmsAdminFeatureKey = 'mmsAdmin';

export interface MmsAdminState extends EntityState<any>, AsyncActionState {
    locations: LocationSet[];
    selected: any;
    selections: any;
    templateOptionsByLocation: any;
    templateByLocation: any;
    searchFilter: SearchFilter;
}

export const adapter: EntityAdapter<any> = createEntityAdapter<any>({
    selectId: (locations: any) => locations,
    sortComparer: null,
});

export const initialState: MmsAdminState = adapter.getInitialState({
    locations: [],
    selected: {},
    selections: {},
    templateOptionsByLocation: [],
    templateByLocation: [],
    searchFilter: null,
    ...asyncActionState.initial,
});

const { loadActions, successActions, errorActions } = AsyncActions;

export const mmsAdminReducer = withLoadables<MmsAdminState>({
    loadActions,
    successActions,
    errorActions,
})(
    initialState,
    on(ManagementBaseActions.initMmsAdmin, (state, action) => ({
        ...initialState,
    })),
    on(MmsAdminActions.loadAllLocationSuccess, (state: MmsAdminState, { locationSets }) => ({
        ...state,
        locations: locationSets,
    })),
    on(MmsAdminActions.select, (state: MmsAdminState, { selected }) => ({
        ...state,
        selected,
    })),
    on(MmsAdminActions.savedSelections, (state: MmsAdminState, { selections }) => ({
        ...state,
        selections,
    })),
    on(MmsAdminActions.loadTemplateOptionsByLocationSuccess, (state: MmsAdminState, { template }) => ({
        ...state,
        templateOptionsByLocation: template,
    })),
    on(MmsAdminActions.loadTemplateOptionsByLocationFailure, (state: MmsAdminState, { error }) => ({
        ...state,
        templateOptionsByLocation: [409]
    })),
    on(MmsAdminActions.loadTemplateByLocationSuccess, (state: MmsAdminState, { template }) => ({
        ...state,
        templateByLocation: template,
    })),
    on(MmsAdminActions.loadTemplateByLocationFailure, (state: MmsAdminState, { error }) => ({
        ...state,
        templateByLocation: error
    })),
);
